import { ArrowDown, Clock, Infinity as InfinityIcon, TrendingUp, Flower2 } from 'lucide-react';
import { SiteLayout } from '../components/site/SiteLayout';
import { PageHero, CheckList, SectionTitle } from '../components/site/PageHero';
import { PhoneButton } from '../components/site/PhoneButton';
import { CallbackForm } from '../components/site/CallbackForm';

const PRODUCTS = [
  { key: 'term', Icon: Clock, title: 'Term Life', copy: 'Affordable protection for a set number of years, while your family needs it most.' },
  { key: 'whole', Icon: InfinityIcon, title: 'Whole Life', copy: 'Lifelong coverage with fixed premiums and cash value that builds over time.' },
  { key: 'iul', Icon: TrendingUp, title: 'Indexed Universal Life (IUL)', copy: 'Permanent coverage with flexible premiums and cash value growth linked to a market index.' },
  { key: 'final-expense', Icon: Flower2, title: 'Final Expense', copy: 'Smaller policies that cover funeral and end-of-life costs so loved ones aren\'t burdened.' },
];

export default function Insurance() {
  return (
    <SiteLayout testid="insurance-page">
      <PageHero
        testid="insurance-hero"
        eyebrow="Life Insurance"
        title="Coverage that protects"
        accent="what matters most"
        intro="Protect your loved ones with life insurance solutions that fit your budget. We explain your options in plain language and help you choose with confidence."
        image="https://images.unsplash.com/photo-1767411354160-4386443abf29"
        imageAlt="Family protected by life insurance"
      >
        <div className="space-y-8">
          <CheckList items={['Term, whole life, IUL and final expense', 'Coverage matched to your family\'s needs', 'Clear, simple explanations']} />
          <div className="flex flex-wrap gap-3">
            <a href="#book" data-testid="insurance-hero-book-link" className="inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 px-7 py-4 font-semibold text-white">
              Request a call back <ArrowDown className="w-4 h-4" />
            </a>
            <PhoneButton type="financial" size="lg" testid="insurance-hero-phone" />
          </div>
        </div>
      </PageHero>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16" data-testid="insurance-products">
        <SectionTitle kicker="Life insurance options" title="Find the policy that fits your life" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PRODUCTS.map(({ key, Icon, title, copy }) => (
            <div key={key} data-testid={`insurance-product-${key}`} className="glass-panel rounded-3xl p-7 hover:border-orange-400/50 hover:-translate-y-1">
              <Icon className="w-8 h-8 text-orange-400 mb-6" />
              <h3 className="font-display text-xl font-semibold text-white mb-2">{title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{copy}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="book" style={{ scrollMarginTop: 96 }} data-testid="insurance-callback" className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionTitle kicker="Call back" title="Request a call back" sub="Leave your details and tell us what you're interested in. A licensed agent will call you at the time that suits you." />
          <PhoneButton type="financial" size="lg" testid="insurance-callback-phone" />
        </div>
        <div className="lg:col-span-7"><CallbackForm /></div>
      </section>
    </SiteLayout>
  );
}
